import { useState, useEffect } from "react";
import { Row, Col, Card, Button, Avatar, message, Form, Modal } from "antd";
import BgProfile from "../assets/cms/profile-background-picture.jpg";
import { Input } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";
import {
  deleteActivityType,
  getActivityType,
  updateActivityType,
} from "../utils/activityTypeApi";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

function ActivityTypeProfile() {
  const location = useLocation();
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  const [activityName, setActivityName] = useState();
  const [loadingData, setLoadingData] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Activity type updated successfully",
    });
    history.push("/activity-types");
  };
  const successDelete = () => {
    messageApi.open({
      type: "success",
      content: "Activity type deleted successfully",
    });
    history.push("/activity-types");
  };
  const showError = () => {
    messageApi.open({
      type: "error",
      content: "Something went wrong. Please try again later.",
    });
  };

  const handleDelete = async () => {
    try {
      await deleteActivityType(id);
      setIsModalOpen(false);
      successDelete();
    } catch (error) {
      setIsModalOpen(false);
      console.log(error);
      showError();
    }
  };

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const fetchActivityType = async () => {
    try {
      setLoadingData(true);
      const data = await getActivityType(id);
      setActivityName(data.activityName);
      setLoadingData(false);
    } catch (error) {
      console.log(error);
      setLoadingData(false);
    }
  };

  const handleUpdate = async () => {
    if (activityName) {
      try {
        await updateActivityType({
          id: id,
          activityName: activityName,
        });
        success();
      } catch (e) {
        console.log(e);
        showError();
      }
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    fetchActivityType();
  }, []);

  return (
    <>
      {contextHolder}

      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      {loadingData ? (
        <Spinner />
      ) : (
        <>
          <Card
            className="card-profile-head"
            bodyStyle={{ display: "none" }}
            title={
              <Row justify="space-between" align="middle" gutter={[24, 0]}>
                <Col span={24} className="col-info">
                  <Avatar.Group>
                    <div className="avatar-info">
                      <h4 className="font-semibold m-0">{activityName}</h4>
                    </div>
                  </Avatar.Group>
                </Col>
              </Row>
            }
          ></Card>

          <Card
            bordered={false}
            className="header-solid mb-24"
            title={
              <>
                <h6 className="font-semibold">Edit Activity Type</h6>
                <p>Edit activity type information below</p>
              </>
            }
          >
            <Row
              style={{
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <Form
                {...formItemLayout}
                form={form}
                name="register"
                onFinish={onFinish}
                style={{
                  width: "80%",
                }}
                scrollToFirstError
              >
                <Form.Item
                  name="activityName"
                  label="Activity name"
                  initialValue={activityName}
                  tooltip="Please provide an activity name"
                  rules={[
                    {
                      required: true,
                      message: "Please input the activity name!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={activityName}
                    onChange={(e) => setActivityName(e.target.value)}
                  />
                </Form.Item>

                <Form.Item {...tailFormItemLayout}>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    type="secondary"
                    className="tag-primary"
                    htmlType="submit"
                    onClick={() => handleUpdate()}
                  >
                    Update Activity Type
                  </Button>

                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    onClick={() => showModal()}
                    type="danger"
                  >
                    DELETE Activity Type
                  </Button>
                  <Modal
                    title="Warning"
                    open={isModalOpen}
                    okText="Delete"
                    okType="danger"
                    onOk={handleDelete}
                    onCancel={handleCancel}
                  >
                    <p>Are you sure you want to delete this activity type?</p>
                  </Modal>
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </>
      )}
    </>
  );
}

export default ActivityTypeProfile;
